<template>
  <div>
    <!-- <v-img
      contain
      max-width="160"
      :width="`${withImg ? withImg : '90'}px`"
      v-if="loadingdir"
    >
      <template v-slot:placeholder>
        <v-row class="fill-height ma-0" align="center" justify="center">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-row>
      </template>
    </v-img> -->
<!-- v-else -->
    <v-img
      contain
      max-width="160"
      :width="`${withImg ? withImg : '90'}px`"
      :src="imgSrc"
    ></v-img>
  </div>
</template>

<script>
  import { mapState,  } from "vuex";

  export default {
    data() {
      return {
        loadingdir: false,
        updateImg: Math.floor(Math.random() * 100)
      };
    },
    methods: {
      ChrEsp(chr) {
        const chrSplit = chr.split("")
        let newChr = ""

        chrSplit.forEach(x => {
          if (x === "/") newChr += "-"
          else if (x === ".") newChr += "-"
          else newChr += x
        })

        return newChr
      }
      
    },
    mounted() {
      this.loadingdir = true
    },
    computed: {
      ...mapState([
        "imgPeque",
        "imgPequeP",
        "imgPequeP2",
        "dataUser",
        "Leerdir",
        "dirPHP",
        "domoapi2_img",
      ]),
      imgSrc() {
        let xSrc = this.domoapi2_img
        xSrc += "Articulo/"
        xSrc += this.ChrEsp(this.codart)
        xSrc += "/Principal?"
        xSrc += "i=" + this.updateImg

        return xSrc
      }
    },
    props: {
      codart: String,
      withImg: Number,
    },
  };
</script>

<style scoped>
  .img_art {
    width: auto;
    height: 50%;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
</style>
